import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BoldIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M17.4 11.6c1-.9 1.6-2.2 1.6-3.6 0-2.8-2.2-5-5-5H6c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h9c2.8 0 5-2.2 5-5 0-1.9-1.1-3.5-2.6-4.4zM7 5h7c1.7 0 3 1.3 3 3s-1.3 3-3 3H7V5zm8 14H7v-6h8c1.7 0 3 1.3 3 3s-1.3 3-3 3z"
                    })
                })
            })
        ]
    });
};
BoldIcon.isCarinaIcon = true;
export default BoldIcon;
